import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../core/auth";
import { GiCook } from "react-icons/gi";
import { FaUser } from "react-icons/fa";
import { HiArrowRight } from "react-icons/hi";

const OnboardingComplete = () => {
  const navigate = useNavigate();
  const { doneSellerOnboarding } = useAuth();

  const handleClick = () => {
    doneSellerOnboarding();
    navigate("/boss/home");
  };

  return (
    <div className="w-full h-[100dvh] overflow-y-auto max-w-[480px] mx-auto bg-white">
      <div className="flex flex-col p-4 w-full space-y-6">
        <div className="space-y-2">
          <h1 className="text-4xl font-bold text-gray-800">요약해볼게요!</h1>
          <p className="text-gray-600">
            두 가지 거래방식의 주요 내용을 정리했어요.
          </p>
        </div>

        {/* 예약 판매 섹션 */}
        <div className="bg-green-50 p-4 rounded-2xl space-y-6">
          <h2 className="text-3xl font-bold text-green-600 text-center">
            1. 예약 판매
          </h2>
          <div className="flex items-center justify-center gap-6 text-center">
            <div className="flex-1 space-y-2">
              <div className="w-16 h-16 mx-auto flex items-center justify-center">
                <FaUser className="w-10 h-10 text-gray-600" />
              </div>
              <p className="bg-white rounded-xl px-3 py-2 font-medium shadow-sm">
                예약 & 결제
              </p>
            </div>
            <div className="text-gray-400">
              <HiArrowRight className="w-8 h-8" />
            </div>
            <div className="flex-1 space-y-2">
              <div className="w-16 h-16 mx-auto flex items-center justify-center">
                <GiCook className="w-16 h-16 text-green-600" />
              </div>
              <p className="bg-white rounded-xl px-3 py-2 font-medium shadow-sm">
                랜덤으로
                <br />
                <strong>담아서 준비</strong>
              </p>
            </div>
          </div>
          <div className="bg-white rounded-xl p-4 space-y-2">
            <p className="text-gray-700 flex items-center gap-2 text-2xl">
              <span className="w-2 h-2 rounded-full bg-green-500" />
              60% 할인
            </p>
            <p className="text-gray-700 flex items-center gap-2 text-2xl">
              <span className="w-2 h-2 rounded-full bg-green-500" />
              수수료는 할인가의 9% 고정
            </p>
            <p className="text-gray-700 flex items-center gap-2 text-2xl">
              <span className="w-2 h-2 rounded-full bg-green-500" />
              구매 완료 후에도 취소 가능
            </p>
          </div>
        </div>

        {/* 실시간 마감할인 섹션 */}
        <div className="bg-blue-50 p-4 rounded-2xl space-y-6">
          <h2 className="text-3xl font-bold text-blue-600 text-center">
            2. 실시간 알림 판매
          </h2>
          <div className="flex items-center justify-center gap-6 text-center">
            <div className="flex-1 space-y-2">
              <div className="w-16 h-16 mx-auto flex items-center justify-center">
                <GiCook className="w-16 h-16 text-primary" />
              </div>
              <p className="bg-white rounded-xl px-3 py-2 font-medium shadow-sm">
                남은 음식
                <br />
                <strong>직접 업로드</strong>
              </p>
            </div>
            <div className="text-gray-400">
              <HiArrowRight className="w-8 h-8" />
            </div>
            <div className="flex-1 space-y-2">
              <div className="w-16 h-16 mx-auto flex items-center justify-center">
                <FaUser className="w-10 h-10 text-gray-600" />
              </div>
              <p className="bg-white rounded-xl px-3 py-2 font-medium shadow-sm">
                결제 & 픽업
              </p>
            </div>
          </div>
          <div className="bg-white rounded-xl p-4 space-y-2">
            <p className="text-gray-700 flex items-center gap-2 text-2xl">
              <span className="w-2 h-2 rounded-full bg-blue-500" />
              30% 이상 할인
            </p>
            <p className="text-gray-700 flex items-center gap-2 text-2xl">
              <span className="w-2 h-2 rounded-full bg-blue-500" />
              수수료는 할인가의 9% 고정
            </p>
            <p className="text-gray-700 flex items-center gap-2 text-2xl">
              <span className="w-2 h-2 rounded-full bg-blue-500" />
              구매 완료 후 취소 어려움
            </p>
          </div>
        </div>

        <button
          onClick={handleClick}
          className="w-full py-3.5 bg-primary text-white font-semibold rounded-2xl transition duration-150 active:brightness-90 pointer-events-auto"
        >
          시작하기
        </button>
      </div>
    </div>
  );
};

export default OnboardingComplete;
